/**
 * Copied verbatim from the faithful port at
 * `features/asset-library/set-pluma-modal-size.ts` (CON-7507). Sets the Pluma
 * modal's min/max width/height via the component's CSS custom properties so
 * the bulk-publish modals can widen beyond the default `size` preset — the
 * same helper parcel's bulk-publish modals used
 * (`app/src/utils/styles/set-pluma-modal-size.ts`).
 */
import { PlumaModal } from '@customerio/pluma-components/css/components';
import { assignInlineVars } from '@vanilla-extract/dynamic';
import { isEmptyString } from '@/utils/string';

export interface PlumaModalSizeOptions {
  minWidth?: string;
  minWidthMobile?: string;
  maxWidth?: string;
  minHeight?: string;
  maxHeight?: string;
}

export function setPlumaModalSize(options: PlumaModalSizeOptions) {
  const { minWidth, minWidthMobile, maxWidth, minHeight, maxHeight } = options;

  return {
    ...assignInlineVars({
      ...(!isEmptyString(minWidth) ? { [PlumaModal.vars.modalMinWidth]: minWidth } : {}),
      ...(!isEmptyString(minWidthMobile) ? { [PlumaModal.vars.modalMinWidthScreenSm]: minWidthMobile } : {}),
      ...(!isEmptyString(maxWidth) ? { [PlumaModal.vars.modalMaxWidth]: maxWidth } : {}),
    }),
    // width/height set as inline styles to ensure the modal dialog element
    // fills to the max. The CSS variable controls the Pluma-internal max.
    ...(!isEmptyString(maxWidth) ? { width: '100%', height: '100%' } : {}),
    ...(!isEmptyString(minHeight) ? { minHeight } : {}),
    ...(!isEmptyString(maxHeight) ? { maxHeight } : {}),
  };
}
